//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import showMask from '@/components/mask/mask.vue'
import moment from 'dayjs'
export default {
	data() {
		return {
			myStrategyList: [], // 列表
			item: {},
			auditModal: false,
			page: {
				pageSize: 10,
				currentPage: 1,
				count: 0,
				loading: false
			},
			titList: [
				// 顶部tab
				{
					title: '已发布',
					code: '1'
				},
				{
					title: '审核中',
					code: '0'
				},
				{
					title: '审核未通过',
					code: '2'
				}
			],
			activeLine: '1', // tab下划线的位置
			state: '1', // 当前tab选项
			//滑动的一些参数
			startX: 0, //开始位置
			endX: 0, //结束位置
			parentElement: 0 //date-type 的值
		}
	},
	components: {
		showMask
	},
	onLoad() {
		this.queryData()
	},
	onPullDownRefresh() {
		this.myStrategyList = []
		this.page.currentPage = 1
		this.queryData()
	},
	onReachBottom() {
		if (this.myStrategyList.length < this.page.count) {
			this.queryData()
		}
	},
	methods: {
		comfirm(item) {
			this.item = item
			this.auditModal = true
		},
		commit() {
			this.auditModal = false
		},
		again(item) {
			uni.navigateTo({
				url:`/pages/strategy/release?id=${item.id}`
			})
		},
		formatTime(d) {
			if (d === null || d === '') {
				return ''
			} else {
				return moment(d).format('YYYY年MM月DD日')
			}
		},
		//滑动开始
		touchStart(e) {
			// 记录初始位置
			this.startX = e.touches[0].pageX;
		},
		//滑动结束
		touchEnd(event, i) {
			// 当前滑动的父级元素
			let query = uni.createSelectorQuery().in(this)
			query.select('.activeBox' + i).boundingClientRect()
			query.exec(res => {
				this.myStrategyList[i].parentElement = res[0].dataset.type
			})
			// 记录结束位置
			this.endX = event.changedTouches[0].pageX
			// 左滑
			if (this.myStrategyList[i].parentElement == 0 && this.startX - this.endX > 30) {
				for (let i = 0; i < this.myStrategyList.length; i++) {
					this.myStrategyList[i].parentElement = 0;
				}
				this.$nextTick(() => {
					this.myStrategyList[i].parentElement = 1
				})
			}
			//右滑
			if (this.myStrategyList[i].parentElement == 1 && this.startX - this.endX < 30) {
				for (let i = 0; i < this.myStrategyList.length; i++) {
					this.myStrategyList[i].parentElement = 0;
				}
				this.$nextTick(() => {
					this.myStrategyList[i].parentElement = 0
				})
			}
			this.startX = 0
			this.endX = 0
		},
		// tab列表选择
		active(val) {
			this.state = val.code
			this.myStrategyList = []
			this.page.currentPage = 1
			this.queryData()
			this.activeLine = val.code
		},
		//获取列表
		queryData() {
			this.page.loading = true
			this.$ajax({
				method: 'post',
				url: '/weChat/cms/touriststrategy/queryList',
				data: {
					memberId: this.$store.state.userInfo.memberId,
					state: this.state,
					...this.page,
				}
			}).then(res => {
				if (res.data) {
					this.page.count = res.count
					let array = []
					res.data.map((t, i) => {
						array.push(
							Object.assign({}, t, {
								parentElement: 0
							})
						)
					})
					this.myStrategyList.push.apply(this.myStrategyList, array)
					this.page.currentPage += 1
				}
				this.page.loading = false
			})
		},
		toDetail(item) {
			if (item.state === 2 || item.state === 0) {
				uni.showToast({
					title: '审核未通过，不能展示详情',
					icon: 'none'
				})
			} else if (item.state === 1) {
				uni.navigateTo({
					url: `/pages/strategy/detail?id=${item.id}&state=3`
				})
			}
		},
		//删除攻略
		delData(item, index) {
			this.myStrategyList[index].parentElement = 1
			let _this = this
			uni.showModal({
				content: '确定要删除这条吗？',
				success(res) {
					if (res.confirm) {
						_this.$ajax({
							method: 'post',
							url: '/weChat/cms/touriststrategy/delete',
							data: {
								id: item.id
							}
						}).then(res => {
							_this.myStrategyList = []
							_this.page.currentPage = 1
							_this.queryData()
						})
					} else if (res.cancel) {

					}
				}
			})
		}
	},
}
